<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container flexs">
            <div class="modal-header closes">
              <h1>Hello, {{ user.name }}</h1>
              <button
                class="modal-default-button"
                @click="$emit('close')"
                v-if="close"
              >
                X
              </button>
            </div>
            <div class="modal-body content">
              <transition name="scale" mode="out-in" tag="div">
                <Slides />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Slides from "./splide.vue";
export default {
  props: ['openMenu'],
  components: {
    Slides,
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  data() {
    return {
      close: false
    }
  }
};
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-around;
}
.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  /* width: 800px;
  height: 500px; */
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #2474b2;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.baner {
  object-fit: cover;
  width: 800px;
  max-width: 100%;
  height: 400px;
  border-radius: 25px;
  margin-bottom: 2px;
}

.flexs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 1200px;
  border-radius: 25px;
  width: 860px;
  border-radius: 25px;
  height: 90vh;
}

.btn {
  width: 60px;
}

.closes {
  align-items: center;
  width: 100%;
}

.closes button {
  height: 45px;
  width: 44px;
  font-size: 37px;
  color: #fff;
  background: none;
  border: none;
  outline: none;
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

h1 {
  font-size: 29px;
  margin: 0;
  padding: p;
  padding: 0;
}
</style>